import React, { FC, useMemo } from 'react';
import { ISignupPhase } from './SignupPhase1';
import { MimaDropdown, MimaInput } from '@/components';
import { useFormState } from 'react-hook-form';

const SignupPhase2: FC<ISignupPhase> = ({ setSignupPhase, control, trigger, touchedFields }) => {
  const { errors } = useFormState({ control });

  const referralSourceData = [
    'Webinar/Seminar',
    'Instagram',
    'Facebook',
    'Twitter',
    'Google Search',
    'Friends & Family',
    'Mima Sales Agent',
    'Others',
  ].map((item) => ({
    key: item,
    value: item,
  }));

  return (
    <div>
      <MimaInput
        labelTitle="Website (Optional)"
        placeholder="Enter your website url"
        id="website"
        name="website"
        error={errors.website}
        touched={touchedFields.website}
        control={control}
        mb={1}
      />

      <MimaInput
        labelTitle="Instagram handle (Optional)"
        placeholder="Enter your instagram handle"
        id="instagramHandle"
        name="instagramHandle"
        error={errors.instagramHandle}
        touched={touchedFields.instagramHandle}
        control={control}
        mb={1}
      />

      <MimaInput
        labelTitle="Twitter handle (Optional)"
        placeholder="Enter your twitter handle"
        id="twitterHandle"
        name="twitterHandle"
        error={errors.twitterHandle}
        touched={touchedFields.twitterHandle}
        control={control}
        mb={1}
      />

      <MimaDropdown
        labelTitle="How did you hear about mima?"
        placeholder="Select"
        name="referralSource"
        data={referralSourceData}
        control={control}
        error={errors.referralSource}
        mb={1}
      />

      <MimaInput
        labelTitle="Password"
        placeholder="Enter your password"
        passwordIcon
        error={errors.password}
        touched={touchedFields.password}
        mb={1}
        name="password"
        control={control}
      />

      <MimaInput
        labelTitle="Referral code (Optional)"
        placeholder="Enter referral code"
        id="referredBy"
        name="referredBy"
        touched={touchedFields.referredBy}
        error={errors.referredBy}
        control={control}
        mb={1}
      />
    </div>
  );
};

export default SignupPhase2;
